export const monthesPeriods = ['1M', '3M', '6M', '1Y'];

export const monthPerLabel = [
  'Last month',
  '3 Months',
  '6 Months',
  '12 Months'
];
